import * as React from "react";
import { cx } from "../../helpers/utils/cx";
import { selectBadgeColors } from "./Badge.utils";
const colorDeprecationMap = {
  purple: "promo",
  green: "action",
  neutral: "neutral",
  red: "danger",
  yellow: "warning"
};
const circularPositions = {
  // 14% offset places the badge on the curved edge of content (like in MUI)
  "top-left": "top-[14%] left-[14%] -translate-x-1/2 -translate-y-1/2",
  "top-right": "top-[14%] right-[14%] translate-x-1/2 -translate-y-1/2",
  "bottom-left": "bottom-[14%] left-[14%] -translate-x-1/2 translate-y-1/2",
  "bottom-right": "bottom-[14%] right-[14%] translate-x-1/2 translate-y-1/2"
};
const rectangularPositions = {
  "top-left": "top-0 left-0 -translate-x-1/2 -translate-y-1/2",
  "top-right": "top-0 right-0 translate-x-1/2 -translate-y-1/2",
  "bottom-left": "bottom-0 left-0 -translate-x-1/2 translate-y-1/2",
  "bottom-right": "bottom-0 right-0 translate-x-1/2 translate-y-1/2"
};
export function Badge(_ref) {
  let {
    badgeContent,
    children,
    color,
    maxCount,
    variant = "standard",
    placement = "top-right",
    placementOverlap = "circular",
    appearance,
    stroke
  } = _ref;
  const isLimitReached = variant === "standard" && maxCount !== undefined && typeof badgeContent === "number" && badgeContent > maxCount;
  let customPropertiesOverride;

  // Configures Badge coloring with CSS Custom Properties
  if (color) {
    // TODO: remove this if statement and the colorDeprecationMap when color prop is removed in major release.
    customPropertiesOverride = selectBadgeColors(colorDeprecationMap[color]);
  }
  if (appearance) {
    customPropertiesOverride = selectBadgeColors(appearance);
  }
  if (!children) {
    return /*#__PURE__*/React.createElement(BadgeWithContent, {
      badgeContent: badgeContent,
      isLimitReached: isLimitReached,
      standalone: true,
      placement: placement,
      placementOverlap: placementOverlap,
      appearance: appearance,
      color: color,
      stroke: stroke
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "kalep-badge-wrapper",
    className: cx("relative inline-flex flex-shrink-0")
  }, children, variant === "standard" ? /*#__PURE__*/React.createElement(BadgeWithContent, {
    badgeContent: badgeContent,
    isLimitReached: isLimitReached,
    placement: placement,
    placementOverlap: placementOverlap,
    appearance: appearance,
    color: color,
    stroke: stroke
  }) : /*#__PURE__*/React.createElement("div", {
    className: cx("rounded-full absolute bg-layer-floor-1", placementOverlap === "circular" ? circularPositions[placement] : rectangularPositions[placement], "inline-flex justify-center items-center", stroke && (variant === "dot" ? "p-[2px]" : "p-[1px]"))
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": variant === "dot" ? "dot-variant-badge" : "s-dot-variant-badge",
    className: cx("badge", variant === "dot" ? "h-3 w-3" : "h-1.5 w-1.5", "rounded-full"),
    style: customPropertiesOverride
  })));
}
function BadgeWithContent(_ref2) {
  let {
    color,
    isLimitReached,
    badgeContent,
    standalone,
    placement,
    placementOverlap,
    appearance,
    stroke
  } = _ref2;
  const isNeutralColor = appearance === "neutral";
  let customPropertiesOverride;

  // Configures Badge coloring with CSS Custom Properties
  if (color) {
    // TODO: remove this if statement and the colorDeprecationMap when color prop is removed in major release.
    customPropertiesOverride = selectBadgeColors(colorDeprecationMap[color]);
  }
  if (appearance) {
    customPropertiesOverride = selectBadgeColors(appearance);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx("rounded-full inline-flex justify-center items-center box-border bg-layer-floor-1", standalone ? "relative" : "absolute", !standalone && (placementOverlap === "circular" ? circularPositions[placement] : rectangularPositions[placement]), stroke && "p-[2px]")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("badge",
    // check Badge.css
    "inline-flex justify-center items-center", "min-w-5 min-h-5 px-1.5", "bolt-font-body-xs-accent rounded-full whitespace-nowrap", isNeutralColor && "text-secondary bg-neutral-secondary-hard"),
    style: customPropertiesOverride
  }, isLimitReached ? /*#__PURE__*/React.createElement("span", {
    "data-testid": "limit-reached-badge",
    className: cx("bg-static-key-light inline-block w-[6px] h-[6px] rounded-full")
  }) : badgeContent));
}